import { getPicture, getPictureLike, pictureLike, } from "@/api/pictureApi.js"
import { Editor } from "@wangeditor/editor-for-vue";
import { method } from "@/common/common.js"
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { jumpData, } from "@/common/commonData.js"
import "swiper/css/swiper.css";
import ImageBar from "@/components/ImageBar/ImageBar.vue"
export default {
    components: {
        swiper,
        swiperSlide,
        ImageBar,
        Editor,
    },
    props: {
        windowWidth: {
            type: Number,
            default: 0,
        },
        path: {
            type: String,
            default: '/picture',
        }
    },
    data() {
        return {
            method,
            jumpData,
            showWindow: false,
            loding: true,
            pictureContent: {},
            pictureList: [],
            swiper: null,
            closeTimeout: null,
            swiperOption: {
                loop: false,
                autoplay: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            imagePaddingTop: 0,
            editor: null,
            mode: "default",
            editorConfig: {
                readOnly: true,
                scroll: false,
            },
            likeData: {
                likeNumber: 0,
                id: null,
            },
        }
    },
    methods: {
        openWindow(id) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
            getPicture({
                id: id
            }).then(res => {
                if (res.code == "0000") {
                    this.showWindow = true;
                    document.querySelector("body").style.overflow = "hidden";
                    if (this.windowWidth > 800) {
                        document.querySelector("body").style.paddingRight = "10px";
                    }
                    this.pictureContent = res.data;
                    this.imagePaddingTop = (((this.pictureContent.coverHeight / this.pictureContent.coverWidth) * 100).toFixed(2)) - 0;
                    this.imagePaddingTop = this.imagePaddingTop > 110 ? 110 : this.imagePaddingTop;
                    if (!method.isNull(this.pictureContent.url)) {
                        this.pictureList = this.pictureContent.url.split(",");
                    }
                    setTimeout(() => {
                        this.loding = false;
                    }, 200);
                    this.getLike();
                } else {
                    method.Message_error(res.msg);
                }
            })
        },
        getLike() {
            getPictureLike({
                id: this.pictureContent.id
            }).then(res => {
                if (res.code == "0000") {
                    this.likeData = res.data;
                }
            })
        },
        clickLike() {
            pictureLike({
                id: this.pictureContent.id
            }).then(res => {
                if (res.code == "0000") {
                    method.Message_success("感谢点赞！");
                    this.getLike();
                } else {
                    method.Message_error(res.msg);
                }
            })
        },
        closeWindow() {
            this.loding = true;
            this.closeTimeout = setTimeout(() => {
                if (this.showWindow == true) {
                    document.querySelector("body").style.overflow = "";
                    document.querySelector("body").style.paddingRight = "";
                }
                this.showWindow = false;
                this.pictureContent = {};
            }, 300);
        },
        onCreated(editor) {
            this.editor = Object.seal(editor);
        },
        // 点击分享
        shareUrl() {
            var cinput = document.createElement("textarea");
            cinput.value = `我发现了一篇好文章！快来看看吧！${window.location.href}`;
            cinput.setAttribute("readOnly", "true");
            document.body.appendChild(cinput);
            cinput.select();
            document.execCommand("Copy");
            cinput.className = "oInput";
            cinput.style.display = "none";
            cinput.style.opacity = "0";
            method.Message_success("链接已经复制到剪贴板中！")
        },
        // 返回上一页
        backPage() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                this.$router.replace(this.path);
            }
        },
        skipWeb(url) {
            window.open(url, '_blank');
        },
        nullFn() {

        },
    },
    watch: {
        $route() {
            if (this.$route.query.pictureId) {
                this.openWindow(this.$route.query.pictureId);
            } else {
                this.closeWindow();
            }
        },
    },
    mounted() {
        if (this.$route.query.pictureId) {
            this.openWindow(this.$route.query.pictureId);
        } else {
            this.closeWindow();
        }
    },
    beforeDestroy() {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
    }
}